<template>
    <div
        id="main-wrapper"
        class="attendee-wrapper"
        :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'"
    >
        <NavbarDark />
        <!-- Exhibit Banner -->
        <div
            v-if="exhibit?.banner"
            class="exhibit-page-banner"
        >
            <img
                :src="exhibit.banner"
                :alt="exhibit.name || 'Exhibit Banner'"
                class="exhibit-banner-image"
            />

            <div class="exhibit-banner-overlay"></div>
            
        </div>

        <div
            v-else
            class="exhibit-page-banner exhibit-banner-placeholder"
        >
            <div class="exhibit-banner-placeholder-icon">
                <i class="fa-solid fa-building"></i>
            </div>
        </div>
        
        <div class="bg-light pb-4">
            
            <div class="container-fluid">
                <div class="row">
                    <div v-if="exhibit?.name" class="exhibit-title" > 
                        <div class="container"> 
                            <h2>{{ exhibit.name }}</h2> 
                        </div> 
                    </div>
                    <div class="col-lg-12 col-md-12">
                        <div class="dashboard-wraper w-100">
                        <div class="form-submit">
                            <div class="submit-section">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="mb-2">{{ t("Full Name") }}<span class="text-danger">*</span></label>
                                        <input
                                        v-model="form.name"
                                        type="text"
                                        class="form-control"
                                        required
                                        />
                                        <small class="text-danger">{{ errors.name?.[0] }}</small>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="mb-2">{{ t("Phone") }}<span class="text-danger">*</span></label>
                                        <input
                                            ref="phoneInput"
                                            type="tel"
                                            class="form-control"
                                            required
                                        />

                                        <small class="text-danger">
                                            {{ errors.phone?.[0] }}
                                        </small>
                                    </div>
                                    
                                    <div class="form-group col-md-6">
                                        <label class="mb-2">{{ t("Email") }}</label>
                                        <input
                                        v-model="form.email"
                                        type="email"
                                        class="form-control"
                                        />
                                        <small class="text-danger">{{ errors.email?.[0] }}</small>
                                    </div>

                                    <div class="form-group col-md-6">
                                        <label class="mb-2">{{ t("Company Name") }}<span class="text-danger">*</span></label>
                                        <input
                                        v-model="form.company_name"
                                        type="text"
                                        class="form-control"
                                        required
                                        />
                                        <small class="text-danger">{{ errors.company_name?.[0] }}</small>
                                    </div>

                                    

                                    <div class="form-group col-md-6 mt-3">
                                        <label class="mb-2">{{ t("Country") }}</label>

                                        <select
                                        v-model="selectedCountry"
                                        class="form-control"
                                        >
                                        <option :value="null">
                                            {{ t("Select Country") }}
                                        </option>

                                        <option
                                            v-for="country in countries"
                                            :key="country.value"
                                            :value="country.value"
                                        >
                                            {{ country.label }}
                                        </option>

                                        </select>

                                        <small class="text-danger">{{ errors.country_id?.[0] }}</small>
                                    </div>

                                    <div class="form-group col-md-6 mt-3">
                                        <label class="mb-2">{{ t("City") }}</label>

                                        <select
                                        v-model="form.city_id"
                                        class="form-control"
                                        >

                                        <option :value="null">
                                            {{ t("Select City") }}
                                        </option>

                                        <option
                                            v-for="city in cities"
                                            :key="city.id"
                                            :value="city.id"
                                        >
                                            {{ city.name }}
                                        </option>

                                        </select>

                                        <small class="text-danger">{{ errors.city_id?.[0] }}</small>

                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="mb-2">{{ t("Job Title") }}</label>
                                        <input
                                        v-model="form.job"
                                        type="text"
                                        class="form-control"
                                        />
                                        <small class="text-danger">{{ errors.job?.[0] }}</small>
                                    </div>
                                    <div
                                        v-if="exhibit?.interests?.length"
                                        class="form-group col-md-6 mt-3"
                                    >
                                        <label class="mb-3">
                                            {{ t("Interests") }}
                                        </label>

                                        <div class="row">
                                            <div
                                                v-for="interest in exhibit.interests"
                                                :key="interest.id"
                                                class="col-md-6 col-sm-6 mb-3"
                                            >
                                                <div class="interest-check">
                                                    <input
                                                        :id="`interest-${interest.id}`"
                                                        v-model="form.interest_ids"
                                                        :value="interest.id"
                                                        class="interest-check-input"
                                                        type="checkbox"
                                                    />

                                                    <label
                                                        :for="`interest-${interest.id}`"
                                                        class="interest-check-label"
                                                    >
                                                        {{ interest.name }}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <small class="text-danger">
                                            {{ errors.interest_ids?.[0] }}
                                        </small>
                                    </div>

                                    <div class="col-12 mt-4">
                                        <button
                                            type="button"
                                            class="btn btn-primary"
                                            :disabled="isSubmitting"
                                            @click="submit"
                                        >
                                            <span v-if="isSubmitting">
                                                {{ t("Saving...") }}
                                            </span>

                                            <span v-else>
                                                {{ t("Save") }}
                                            </span>
                                        </button>
                                    </div>

                                </div>                        
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div v-if="qrCode" class="text-center mt-4">
                    <h4>{{ t("Your QR Code") }}</h4>

                    <img
                        v-if="qrCode"
                        :src="qrCode"
                        alt="QR Code"
                        style="width: 250px; height: 300px;"
                    />

                    <div class="mt-3">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="downloadQr"
                        >
                            {{ t("Download") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <FooterTop :bg="'theme-bg'" />
        <FooterDark />
        <ScrollToTop />
    </div>
</template>
<script setup>
import FooterDark from '@/components/footer/footer-dark.vue'
import FooterTop from '@/components/footer/footer-top.vue'
import NavbarDark from '@/components/navbar/navbar-dark.vue'
import ScrollToTop from '@/components/scroll-to-top.vue'
import { ref, onMounted, watch, onBeforeUnmount } from 'vue';

import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/css/intlTelInput.css";
import { useRoute } from 'vue-router';
import axios from 'axios';
import { useToast } from 'vue-toastification';
import { useI18n } from "vue-i18n";
const toast = useToast();
const { t,locale } = useI18n();
const cities = ref([]);
const countries = ref([]);
const selectedCountry = ref(null);
const phoneInput = ref(null);
const phoneValid = ref(false);
let iti = null;
const route = useRoute();
const qrCode = ref(null);
const isSubmitting = ref(false);
const exhibit = ref(null);
const exhibitLoading = ref(true);

const form = ref({
    exhibit_code: route.params.code || "",
    name: "",
    email: "",
    phone: "",
    company_name: "",
    job: "",
    country_id: null,
    city_id: null,
    interest_ids: [],
});

const errors = ref({});
const attendeeCode = ref('');
const attendeeName = ref('');
const fetchCountries = async () => {
  try {
    const response = await axios.get("/countries/All", {
      params: { lang: locale.value }
    });

    if (response.data && Array.isArray(response.data.data)) {
      countries.value = response.data.data
        .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
        .map(country => ({
          label: country.name,
          value: country.id
        }));
    }
  } catch (error) {
    console.error("Error fetching countries:", error);
  }
};
const fetchCities = async () => {
    if (!selectedCountry.value) {
        cities.value = [];
        form.value.city_id = null;
        return;
    }
    try {
        const response = await axios.get(`/countries/${selectedCountry.value}`,
            {
                params:{
                    lang: locale.value
                }
            }
        );
        cities.value = response.data.data.cities;
        form.value.country_id = selectedCountry.value;
    } catch (error) {
        console.error(error);
    }
};

const fetchExhibit = async () => {
    try {
        exhibitLoading.value = true;

        const code = route.params.code;

        if (!code) {
            return;
        }

        const response = await axios.get(
            `/detail/exhibit/${code}`,
            {
                params: {
                    lang: locale.value
                }
            }
        );

        if (response.data.success) {
            exhibit.value = response.data.data;
        }

    } catch (error) {

        console.error("Error fetching exhibit:", error);

        exhibit.value = null;

    } finally {

        exhibitLoading.value = false;

    }
};

const submit = async () => {
    if (isSubmitting.value) return;

    errors.value = {};
    isSubmitting.value = true;

    if (!iti.isValidNumber()) {

        errors.value.phone = [
            t("Invalid phone number")
        ];
        isSubmitting.value = false;
        return;

    }

    form.value.phone = iti.getNumber();

    try {

        const formData = new FormData();

        formData.append('exhibit_code', form.value.exhibit_code);
        formData.append('name', form.value.name);
        formData.append('email', form.value.email ?? '');
        formData.append('phone', form.value.phone);
        formData.append('company_name', form.value.company_name ?? '');
        formData.append('job', form.value.job ?? '');
        formData.append('country_id', form.value.country_id ?? '');
        formData.append('city_id', form.value.city_id ?? '');

        form.value.interest_ids.forEach((interestId) => {
            formData.append('interest_ids[]', interestId);
        });

        const response = await axios.post(
            "/exhibit/attendees",
            formData,
            {
                params: {
                    lang: locale.value
                }
            }
        );

        if (response.data.success) {
            qrCode.value = response.data.qr;
            attendeeCode.value = response.data.attendee_code;
            attendeeName.value = response.data.name;
            toast.success(t("Save Successfully"));

            form.value = {
                exhibit_code: route.params.code || "",
                name: "",
                email: "",
                phone: "",
                company_name: "",
                job: "",
                country_id: null,
                city_id: null,
                interest_ids: [],
            };

            errors.value = {};
        }
    } catch (error) {
        if (error.response?.status === 422) {

            if (error.response.data.errors) {
                Object.values(error.response.data.errors).forEach(messages => {
                toast.error(messages[0]);
                });
            }
            else if (error.response.data.message) {
                toast.error(error.response.data.message);
            }
            return;
        }

        toast.error(
        error.response?.data?.message || t("Failed to save exhibits")
        );

        console.error(error);

    }finally {
        isSubmitting.value = false;
    }

};

const downloadQr = () => {
    if (!qrCode.value) return;

    const link = document.createElement('a');

    link.href = qrCode.value;
    link.download = 'attendee-qr.png';

    document.body.appendChild(link);
    link.click();
    link.remove();
};

onMounted(async () => {
    await fetchExhibit();
    fetchCountries();
    iti = intlTelInput(phoneInput.value, {
        initialCountry: "sy",
        separateDialCode: true,
        strictMode: true,
        autoPlaceholder: "off",

        loadUtils: () =>
        import("intl-tel-input/build/js/utils.js")

    });

    await new Promise(resolve => setTimeout(resolve, 300));

    phoneInput.value.addEventListener("input", updatePhone);
    phoneInput.value.addEventListener("countrychange", updatePhone);

    updatePhone();
});
onBeforeUnmount(() => {
    if (phoneInput.value) {
        phoneInput.value.removeEventListener("input", updatePhone);
        phoneInput.value.removeEventListener("countrychange", updatePhone);
    }

    if (iti) {
        iti.destroy();
    }
});

function updatePhone() {
    if (!iti) return;

    phoneValid.value = iti.isValidNumber();

    try {
        form.value.phone = iti.getNumber(); 
    } catch {
        form.value.phone = phoneInput.value.value;
    }
}

watch(locale, () => {
    fetchExhibit();
    fetchCountries();
    if (selectedCountry.value) fetchCities();
});

watch(selectedCountry, () => {
    fetchCities();
});

</script>
<style>
.iti {
    width: 100%;
}

.iti input {
    width: 100%;
}
.iti__flag {
    background-image: url("~@/assets/img/flags.webp");
}

@media (-webkit-min-device-pixel-ratio: 2),
(min-resolution: 192dpi) {
    .iti__flag {
        background-image: url("~@/assets/img/flags@2x.webp");
    }
}

.exhibit-page-banner {
    position: relative;

    width: 100%;

    height: clamp(180px, 25vw, 420px);

    overflow: hidden;

    background: #17232c;
}

.exhibit-banner-image {
    width: 100%;
    height: 100%;

    display: block;

    object-fit: cover;
    object-position: center;
}

.exhibit-banner-overlay {
    position: absolute;

    inset: 0;

    background:
        linear-gradient(
            to bottom,
            rgba(0, 0, 0, 0.05),
            rgba(0, 0, 0, 0.55)
        );
}

.exhibit-title {
    width: 100%;
    padding: 20px 0;
}

.exhibit-title h2 {
    margin: 0;
    text-align: center;
    color: #6A715D;
    font-size: 28px;
    font-weight: 700;
}

/* Mobile */
@media (max-width: 575px) {
    .exhibit-title {
        padding: 15px 0;
    }

    .exhibit-title h2 {
        font-size: 21px;
    }
}


/* No banner */

.exhibit-banner-placeholder {
    display: flex;

    align-items: center;
    justify-content: center;
}

.exhibit-banner-placeholder-icon {
    width: 70px;
    height: 70px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;

    background: rgba(255, 255, 255, 0.08);

    color: #ffffff;

    font-size: 28px;
}


/* Mobile */

@media (max-width: 575px) {

    .exhibit-page-banner {
        height: 150px;
    }

    .exhibit-banner-content {
        left: 15px;
        right: 15px;
        bottom: 18px;
    }

    .exhibit-banner-content p {
        font-size: 21px;
    }

}
.interest-check {
    display: flex;
    align-items: center;
    gap: 8px;
    width: fit-content;
}

.interest-check-input {
    width: 16px;
    height: 16px;
    margin: 0 !important;
    flex-shrink: 0;
    cursor: pointer;
}

.interest-check-label {
    margin: 0;
    padding: 0;
    cursor: pointer;
    line-height: 1.5;
}

/* RTL */
[dir="rtl"] .interest-check {
    flex-direction: row;
}
</style>